import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ProductCard, ProductCardSkeleton } from "@/components/ProductCard";
import RichText from "@/components/RichText";

// "collection_id" est le slug de la catégorie (les catégories n'ont pas de
// champ "id" séparé — voir theme_service.py, registre _CATALOG_REF_COLLECTIONS).
// Réutilise ProductCard (déjà utilisé sur la page Boutique) pour un rendu et
// un comportement panier identiques partout sur le site.
export default function FeaturedCollectionSection({ props = {} }) {
  const { collection_id, heading, products_limit } = props;
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (!collection_id) { setCategory(null); setProducts(null); return; }
    let cancelled = false;
    api.get("/categories").then(({ data }) => {
      if (!cancelled) setCategory((data || []).find((c) => c.slug === collection_id) || null);
    }).catch(() => {});
    api.get("/products", { params: { category: collection_id, limit: Number(products_limit) || 4 } }).then(({ data }) => {
      if (!cancelled) setProducts(data || []);
    }).catch(() => { if (!cancelled) setProducts([]); });
    return () => { cancelled = true; };
  }, [collection_id, products_limit]);

  if (!collection_id) return null;

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      <div className="flex items-end justify-between gap-4 mb-8">
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink"
          html={heading || category?.name || ""}
        />
        {category?.slug && (
          <Link to={`/categorie/${category.slug}`} className="text-[14px] font-medium text-gold hover:text-ink transition-colors shrink-0">
            Tout voir
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
        {products === null
          ? Array.from({ length: Number(products_limit) || 4 }).map((_, i) => <ProductCardSkeleton key={i} />)
          : products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
      </div>
    </section>
  );
}
